(function () {
  'use strict';
  var routes = {
    '/pages/still-on-guard-series': {offer: 'sog', variant: '53920606486861', audio: 'https://cdn.shopify.com/s/files/1/0912/8004/8461/files/still-on-guard-audio-preview.mp3'},
    '/pages/always-on-always-behind': {offer: 'aoab', variant: '54298671317325', audio: 'https://cdn.shopify.com/s/files/1/0912/8004/8461/files/always-on-always-behind-audio-preview_c94ded2e-e247-4c6a-852a-ab258c254d36.mp3'},
    '/pages/the-return-point': {offer: 'rp', variant: '54506584768845', audio: 'https://talk2tessa.com/cdn/shop/t/25/assets/sales-return-for-a-replaying-mind.mp3'}
  };
  var route = routes[location.pathname.replace(/\/$/, '')];
  if (!route || window.__t2tDirectOffers20261001) return;
  window.__t2tDirectOffers20261001 = true;
  function allowed() {
    try { return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true && typeof window.gtag === 'function'; }
    catch (_) { return false; }
  }
  function send(name) {
    if (!allowed()) return false;
    try { window.gtag('event', name, {send_to: 'G-TEQRFML1TZ', offer: route.offer, placement: 'direct_offer_page', transport_type: 'beacon'}); }
    catch (_) {}
    return true;
  }
  var buttonAttempted = false;
  document.addEventListener('click', function (event) {
    if (!event.isTrusted || buttonAttempted || !allowed()) return;
    var anchor = event.target && event.target.closest && event.target.closest('a[href]');
    if (!anchor) return;
    var url;
    try { url = new URL(anchor.href, location.href); } catch (_) { return; }
    if (url.origin !== 'https://talk2tessa.com' || url.pathname !== '/cart/' + route.variant + ':1') return;
    buttonAttempted = true;
    send('t2t_direct_checkout_click');
  }, true);
  var states = new WeakMap();
  var allStates = [];
  function stateFor(audio) {
    if (!(audio instanceof HTMLAudioElement)) return null;
    var url;
    try { url = new URL(audio.currentSrc || audio.src, location.href); } catch (_) { return null; }
    if (url.origin + url.pathname !== route.audio) return null;
    if (!states.has(audio)) {
      var initial = {started: false, completed: false, valid: false, lastTime: 0, lastWall: 0, ranges: []};
      states.set(audio, initial); allStates.push(initial);
    }
    return states.get(audio);
  }
  document.addEventListener('play', function (event) {
    if (!event.isTrusted || !allowed()) return;
    var state = stateFor(event.target);
    if (!state || state.completed) return;
    state.valid = true; state.lastTime = event.target.currentTime; state.lastWall = Date.now();
    if (!state.started) { state.started = true; send('t2t_direct_preview_start'); }
  }, true);
  function completion(event) {
    if (!event.isTrusted || !allowed()) return;
    var audio = event.target, state = stateFor(audio);
    if (!state || !state.valid || !state.started || state.completed || !Number.isFinite(audio.duration) || audio.duration <= 0) return;
    var now = Date.now(), delta = audio.currentTime - state.lastTime;
    if (!audio.seeking && delta > 0 && delta <= (now - state.lastWall) / 1000 * audio.playbackRate + 0.25) {
      state.ranges.push([state.lastTime, audio.currentTime]);
      state.ranges.sort(function (a, b) { return a[0] - b[0]; });
      var merged = [];
      state.ranges.forEach(function (range) {
        var last = merged[merged.length - 1];
        if (last && range[0] <= last[1]) last[1] = Math.max(last[1], range[1]);
        else merged.push(range.slice());
      });
      state.ranges = merged;
    }
    state.lastTime = audio.currentTime; state.lastWall = now;
    var seconds = state.ranges.reduce(function (sum, range) { return sum + range[1] - range[0]; }, 0);
    if (seconds < audio.duration * 0.95) return;
    state.completed = true;
    send('t2t_direct_preview_complete');
  }
  document.addEventListener('timeupdate', completion, true);
  document.addEventListener('ended', completion, true);
  document.addEventListener('pause', completion, true);
  document.addEventListener('seeking', function (event) {
    var state = stateFor(event.target);
    if (state) { state.lastTime = event.target.currentTime; state.lastWall = Date.now(); }
  }, true);
  document.addEventListener('visitorConsentCollected', function () {
    if (!allowed()) allStates.forEach(function (state) { state.valid = false; state.ranges = []; });
  });
})();
